<ng-container *ngIf="items$ | async as items">
  <p-breadcrumb class="max-w-full" [model]="items" [home]="home"></p-breadcrumb>
</ng-container>
